/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ZoomService } from '../../../modules/shared/services/zoom.service';

@Component({
    selector: 'dash-gis-zoom-button',
    template: ` <button mat-icon-button (click)="zoomTo()">
        <mat-icon svgIcon="zoom-in" aria-label="Zoom"></mat-icon>
    </button>`,
})
export class ZoomButtonComponent implements OnInit {
    @Output() public zoom = new EventEmitter<void>();
    @Input() public zoomLayer: string;
    @Input() public zoomObjectField: string;
    @Input() public zoomObjectKey: any;

    constructor(private zoomService: ZoomService) {}

    ngOnInit(): void {}

    public zoomTo() {
        this.zoom.next();

        this.zoomService.zoom(this.zoomLayer, this.zoomObjectField, this.zoomObjectKey);
    }
}
